<template>
  <a-modal :title="viewTitle" visible @cancel="cancel">
    <ak-inputs :options="options" ref="inputs" v-model="record" />
    <template slot="footer">
      <a-button :loading="loading" type="primary" @click="ok">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'viewPage',
  data () {
    return {
      loading: false,
      options: [
        {
          name: 'name',
          note: '活动名称',
          type: 'String',
          validators: [
            // 表单验证，与model中的validators用法一致
            (val) => (val ? null : '不可为空')
          ]
        },
        {
          name: 'type',
          note: '发放类型',
          type: 'Select',
          items: {
            property: '缴纳物业费',
            heating: '缴纳取暖费',
            login: '登录'
          }
        },
        {
          name: 'isEnable',
          note: '是否启用',
          type: 'Boolean'
        },
        {
          name: 'residentialQuarters',
          note: '参与小区',
          type: 'Array',
          items: {
            type: 'Pointer',
            targetClass: 'residentialQuarters',
            searchKey: ['name']
          }
        },
        {
          name: 'details',
          note: '代金券详情',
          type: 'Array',
          items: {
            type: 'Object',
            items: [
              {
                name: 'name',
                note: '代金券名称',
                type: 'String'
              },
              {
                name: 'shopType',
                note: '代金券类型',
                type: 'Select',
                items: {
                  unconditional: '无条件',
                  reduction: '满减'
                }
              },
              {
                name: 'total',
                note: '发放数量',
                type: 'Number'
              },
              {
                name: 'shopAmount',
                note: '使用金额',
                tooltip: '无条件类型，金额为0,，满减需要设置金额',
                type: 'Number'
              },
              {
                name: 'shopQuota',
                note: '抵扣金额',
                type: 'Number'
              }
            ]
          }
        },
        {
          name: 'day',
          note: '代金券有效天数',
          type: 'Number'
        }
      ],
      record: {}
    }
  },
  mounted () {},
  methods: {
    cancel () {
      this.$emit('complete', 'cancel')
    },
    async ok () {
      this.loading = true
      // 验证数据格式
      if (
        !this.record.name ||
        !this.record.type ||
        !this.record.day ||
        !this.record.details ||
        this.record.details.length === 0
      ) {
        this.loading = false
        return this.$notification['error']({
          message: '数据错误',
          description: '请填写所有信息'
        })
      }
      if (this.record.type !== 'login') {
        if (
          !this.record.residentialQuarters ||
          this.record.details.residentialQuarters === 0
        ) {
          this.loading = false
          return this.$notification['error']({
            message: '数据错误',
            description: '取暖费与物业费必须选择参与小区'
          })
        }
      }
      if (!/^[1-9]\d*$/.test(this.record.day)) {
        this.loading = false
        return this.$notification['error']({
          message: '数据错误',
          description: '请正确填写代金券有效天数'
        })
      }
      // 验证表单
      for (let i in this.record.details) {
        let item = this.record.details[i]
        if (!item.name || !item.shopType) {
          this.loading = false
          return this.$notification['error']({
            message: '数据错误',
            description: '请填写所有信息'
          })
        }
        if (!item.shopQuota || item.shopQuota <= 0) {
          this.loading = false
          return this.$notification['error']({
            message: '数据错误',
            description: '请正确填写抵扣金额'
          })
        }
        if (!/^[1-9]\d*$/.test(item.total)) {
          this.loading = false
          return this.$notification['error']({
            message: '数据错误',
            description: '请正确填写发放数量'
          })
        }
        if (item.shopAmount == null || item.shopAmount < 0) {
          this.loading = false
          return this.$notification['error']({
            message: '数据错误',
            description: '请正确填写使用金额'
          })
        }
      }
      // 循环创建购物代金券并保存id
      let couponId = []
      for (let i in this.record.details) {
        // 创建代金券
        let { data } = await this.$tkParse.post('/classes/coupon', {
          name: this.record.details[i].name,
          shopType: this.record.details[i].shopType,
          shopAmount:
            this.record.details[i].shopType === 'reduction'
              ? this.record.details[i].shopAmount
              : 0,
          shopQuota: this.record.details[i].shopQuota,
          total: this.record.details[i].total,
          surplus: this.record.details[i].total,
          couponType: 'shopping',
          isDel: false
        })
        couponId.push(data.objectId)
      }
      // 创建代金券活动
      await this.$tkParse.post('/classes/couponActivity', {
        name: this.record.name,
        type: this.record.type,
        day: this.record.day,
        details: couponId,
        residentialQuarters: this.record.residentialQuarters || [],
        isEnable: this.record.isEnable || false
      })
      this.loading = false
      this.cancel()
      this.vm.refresh()
    }
  },
  props: {
    // record: Object, // 当前行的数据
    model: Object, // 当前model对象
    field: Object, // 当前field对象
    vm: Object, // 当前页面的vm对象
    viewTitle: {
      type: String,
      default: '新建代金券活动'
    }
  }
}
</script>

<style scoped>
</style>
